import { useLanguage } from "../hooks/useLanguage";
import { DEFAULT_TAX_CONFIG } from "../firebase/schema";

// Phần bảo hiểm + thuế TNCN + thực nhận của một tháng.
// Dùng chung cho dashboard promoter, bảng lương admin và bảng lương supervisor —
// ba vai trò phải nhìn thấy cùng một cách diễn giải, không chỉ cùng con số cuối.
export default function DeductionBreakdown({ ded, taxCfg = DEFAULT_TAX_CONFIG }) {
  const { t } = useLanguage();
  if (!ded) return null;

  const c = { ...DEFAULT_TAX_CONFIG, ...(taxCfg || {}) };
  const money = (v) => Number(v || 0).toLocaleString("vi-VN") + " đ";
  const pct = (v) => String(v).replace(".", ",");
  const sub = { color: "#777", fontSize: 13 };
  const secHeader = { fontWeight: 600, fontSize: 13, color: "#444", margin: "10px 0 2px" };

  return (
    <>
      {ded.probation ? (
        <div className="alert alert-info" style={{ fontSize: 12, margin: "10px 0 4px" }}>
          {ded.flatRate != null ? t("inc.probation_flat_note", { pct: pct(ded.flatRate) }) : t("inc.probation_note")}
        </div>
      ) : (
        <>
          <div style={secHeader}>{t("inc.emp_ins")}</div>
          <div className="salary-row" style={sub}><span>BHXH ({pct(c.empSiPct)}%)</span><span>− {money(ded.empSI)}</span></div>
          <div className="salary-row" style={sub}><span>BHYT ({pct(c.empHiPct)}%)</span><span>− {money(ded.empHI)}</span></div>
          <div className="salary-row" style={sub}><span>BH thất nghiệp ({pct(c.empUiPct)}%)</span><span>− {money(ded.empUI)}</span></div>
          <div className="salary-row" style={{ fontWeight: 600, color: "#A32D2D" }}>
            <span>{t("inc.total_emp")}</span><span>− {money(ded.empTotal)}</span>
          </div>
        </>
      )}

      <div style={secHeader}>{t("inc.tax_section")}</div>
      <div className="salary-row" style={sub}><span>{t("inc.taxable")}</span><span>{money(ded.assessable)}</span></div>
      {ded.mealExempt > 0 && (
        <div className="salary-row" style={sub}><span>{t("inc.meal_exempt")}</span><span>− {money(ded.mealExempt)}</span></div>
      )}
      {ded.nonTaxable > 0 && (
        <div className="salary-row" style={sub}><span>{t("inc.ot_exempt")}</span><span>− {money(ded.nonTaxable)}</span></div>
      )}
      {!ded.probation && (
        <>
          <div className="salary-row" style={sub}><span>{t("inc.personal_ded")}</span><span>− {money(ded.personalDeduction)}</span></div>
          {ded.dependentDeduction > 0 && (
            <div className="salary-row" style={sub}><span>{t("inc.dependent_ded")}</span><span>− {money(ded.dependentDeduction)}</span></div>
          )}
        </>
      )}
      <div className="salary-row" style={sub}><span>{t("inc.taxable_base")}</span><span>{money(ded.taxable)}</span></div>
      <div className="salary-row" style={{ fontWeight: 600, color: "#A32D2D" }}>
        <span>{t("inc.pit")}{ded.flatRate != null && ` (${pct(ded.flatRate)}%)`}</span><span>− {money(ded.pit)}</span>
      </div>

      <div className="salary-row" style={{ fontWeight: 700, fontSize: 15, borderTop: "1px solid #eee", paddingTop: 10, marginTop: 8, color: "#1D9E75" }}>
        <span>✅ {t("inc.net")}</span><span>{money(ded.net)}</span>
      </div>
    </>
  );
}
